<template>
	<div v-if="!publicNav">
		<div v-if="isMobile">
			<v-navigation-drawer v-model="drawer" class="navigation" app>
				<template v-if="isLoggedIn">
					<router-link
						v-for="link in accessibleLinks"
						:key="link.name"
						:to="link.path"
						:class="[$route.path == link.path ? 'nav-link-active' : null]"
						class="nav-link"
					>
						<v-list nav>
							<v-list-item :key="link.title" link v-if="isVisible(link)">
								<v-list-item-icon class="nav-icon">
									<v-icon>{{ link.icon }}</v-icon>
								</v-list-item-icon>

								<v-list-item-content>
									<v-list-item-title class="nav-title">{{ link.name }}</v-list-item-title>
								</v-list-item-content>
							</v-list-item>
						</v-list>
					</router-link>
				</template>
				<template v-else>
					<router-link
						v-for="link in publicLinks"
						:key="link.name"
						:to="link.path"
						:class="[$route.path == link.path ? 'nav-link-active' : null]"
						class="nav-link"
					>
						<v-list nav>
							<v-list-item :key="link.title" link>
								<v-list-item-icon class="nav-icon">
									<v-icon>{{ link.icon }}</v-icon>
								</v-list-item-icon>

								<v-list-item-content>
									<v-list-item-title class="nav-title">{{ link.name }}</v-list-item-title>
								</v-list-item-content>
							</v-list-item>
						</v-list>
					</router-link>
				</template>
			</v-navigation-drawer>

			<v-app-bar class="top-navigation" app height="60">
				<v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
				<img src="@/assets/svg/Chemformation_logo_Horz.svg" height="25" />

				<v-spacer></v-spacer>

				<v-menu offset-y v-if="user">
					<template v-slot:activator="{ on, attrs }">
						<v-btn icon v-bind="attrs" v-on="on">
							<v-icon size="36">mdi-account-circle</v-icon>
						</v-btn>
					</template>

					<v-list>
						<v-list-item link>
							<v-list-item-content>
								<v-list-item-title class="text-h6">
									{{ user.firstName }} {{ user.lastName }}
								</v-list-item-title>
								<v-list-item-subtitle>{{ user.email }}</v-list-item-subtitle>
							</v-list-item-content>
						</v-list-item>

						<v-divider></v-divider>

						<v-list-item @click="$router.push('/account')">
							<v-list-item-title>My Account</v-list-item-title>
						</v-list-item>

						<v-list-item @click="logout()">
							<v-list-item-title>Logout</v-list-item-title>
						</v-list-item>
					</v-list>
				</v-menu>
			</v-app-bar>
		</div>
		<div v-else class="nav top-navigation">
			<div class="heading">
				<img
					v-if="isLogoVisible"
					src="@/assets/svg/Chemformation_logo_Horz.svg"
					hspace="0"
					vspace="0"
					style="height: 100%"
				/>
				<div class="social nav-socials">
					<a href="https://www.linkedin.com/company/chemformation" target="_blank">
						<img src="@/assets/LinkedIn-social-icons.png" alt="" align="absMiddle" border="0" />
					</a>
				</div>
			</div>
			<div id="menu">
				<template v-if="isLoggedIn">
					<router-link
						v-for="link in accessibleLinks"
						:key="link.name"
						:to="link.path"
						:class="[$route.path == link.path ? 'nav-link-active' : null]"
						class="custom-button mi ui-menu nav-link"
					>
						{{ link.name }}
					</router-link>
					<button
						type="button"
						class="custom-button mi ui-menu nav-link"
						style="color: #ba0c2f"
						v-if="isLogoVisible"
						@click="logout()"
					>
						Logout
					</button>
				</template>
				<!-- <template v-else>
					<router-link
						v-for="link in publicLinks"
						:key="link.name"
						:to="link.path"
						:class="[$route.path == link.path ? 'nav-link-active' : null]"
						class="custom-button mi ui-menu nav-link"
					>
						{{ link.name }}
					</router-link>
				</template> -->
			</div>
		</div>
	</div>

	<!--
		Public header. The whole header is sticky with a negative top offset, so as the page
		scrolls the logo region slides away naturally and only the bottom strip stays pinned.
		Row heights are fixed in CSS, so page content is flush below it without any measuring.
		The logos crossfade in step with scroll position through the --p custom property.
	-->
	<header v-else ref="publicHeader" class="public-header">
		<div class="public-header-top">
			<router-link to="/login" class="logo-link" aria-label="Chemformation home">
				<img class="logo-primary" src="@/assets/svg/Chemformation_logo_Primary.svg" alt="Chemformation" />
			</router-link>
		</div>
		<div ref="publicStrip" class="public-header-strip">
			<img
				class="logo-horizontal"
				src="@/assets/svg/Chemformation_logo_Horz.svg"
				alt=""
				aria-hidden="true"
			/>
			<nav class="public-links" aria-label="Site">
				<router-link
					v-for="link in publicBarLinks"
					:key="link.path"
					:to="link.path"
					class="uppercase custom-button"
				>
					{{ link.name }}
				</router-link>
			</nav>
		</div>
	</header>
</template>

<script>
import { usesPublicNav } from "@/utils/publicNav";

export default {
	name: "Navigation",
	data() {
		return {
			publicLinks: [
				{
					path: "/login",
					name: "Login",
					icon: "mdi-login",
				},
				{
					path: "/contact",
					name: "Contact Us",
					icon: "mdi-card-account-mail",
				},
				{
					path: "/request",
					name: "Request Access",
					icon: "mdi-account-plus",
				},
				{
					path: "/supplier-partner",
					name: "Supplier Partner",
					icon: "mdi-account-tie",
				},
				{
					path: "/tutorial",
					name: "Video Demo",
					icon: "mdi-video",
				},
				// Reachable at /ai-assistants but not advertised yet; see publicBarLinks below.
				// { path: "/ai-assistants", name: "AI Assistants", icon: "mdi-comment-text-outline" },
			],
			privateLinks: [
				{
					path: "/product-search",
					name: "Product Search",
					isAdmin: false,
					icon: "mdi-flask",
				},
				{
					path: "/internet-search",
					name: "Internet Search",
					isAdmin: false,
					icon: "mdi-magnify",
				},
				{
					path: "/formulations",
					name: "Formulations",
					isAdmin: false,
					icon: "mdi-mortar-pestle-plus",
				},
				{
					path: "/faq",
					name: "FAQ",
					isAdmin: false,
					icon: "mdi-frequently-asked-questions",
				},
				{
					path: "/glossary",
					name: "Glossary",
					isAdmin: false,
					icon: "mdi-book-open-variant",
				},
				{
					path: "/contact",
					name: "Contact Us",
					isAdmin: false,
					icon: "mdi-card-account-mail",
				},
				{
					path: "/account",
					name: "Account",
					isAdmin: false,
					icon: "mdi-account",
				},
				{
					path: "/mail",
					name: "Mail",
					isAdmin: true,
					icon: "mdi-email-search-outline",
				},
			],
			isLogoVisible: true,
			drawer: null,
			user: null,
			publicBarLinks: [
				{ path: "/request", name: "Request Access" },
				{ path: "/contact", name: "Contact Us" },
				{ path: "/tutorial", name: "Video Demo" },
				// The AI Assistants page is reachable at /ai-assistants but not advertised in the public nav yet.
				// { path: "/ai-assistants", name: "AI Assistants" },
			],
		};
	},
	methods: {
		logout() {
			this.$store
				.dispatch("logout")
				.then(() => {
					this.user = null;
					this.$router.push("/");
				})
				.catch((error) => {
					console.log(error);
				});
		},
		isVisible(link) {
			let isVisible = link.isAdmin ? this.isAdmin : true;
			return isVisible;
		},
		onScroll() {
			const header = this.$refs.publicHeader;
			const strip = this.$refs.publicStrip;
			if (!header || !strip) return;
			const range = header.offsetHeight - strip.offsetHeight;
			const y = window.scrollY || 0;
			const p = range > 0 ? Math.min(1, Math.max(0, y / range)) : 1;
			header.style.setProperty("--p", p.toFixed(3));
		},
		emitNavHeight() {
			if (this.publicNav) {
				// The public header is in normal flow; the page needs no top offset.
				this.$emit("navHeight", "0px");
				return;
			}
			const elements = document.getElementsByClassName("top-navigation");
			console.log(elements.length, elements, elements[0]);
			const paddingTop = elements.length > 0 ? elements[0].clientHeight + "px" : "0px";
			this.$emit("navHeight", paddingTop);
			console.log(paddingTop);
		},
	},
	computed: {
		isLoggedIn() {
			return this.$store.getters.isLoggedIn;
		},
		isMobile() {
			// Read from the breakpoint on every render so the drawer follows live resizes and
			// device-mode switches, not just the width at load.
			return this.$vuetify.breakpoint.smAndDown;
		},
		publicNav() {
			return usesPublicNav(this.$route.path, this.isLoggedIn);
		},
		isAdmin() {
			return this.$store.getters.isAdmin;
		},
		accessibleLinks() {
			return this.privateLinks.filter((link) => this.isVisible(link));
		},
	},
	updated() {
		this.user = this.$store.getters.userInfo;
		this.emitNavHeight();
	},
	mounted() {
		this.user = this.$store.getters.userInfo;
		if (window.location !== window.parent.location) {
			// The page is in an iframe
			this.isLogoVisible = false;
		}

		window.addEventListener("resize", this.emitNavHeight);
		window.addEventListener("scroll", this.onScroll, { passive: true });
		this.onScroll();
	},
	beforeDestroy() {
		window.removeEventListener("resize", this.emitNavHeight);
		window.removeEventListener("scroll", this.onScroll);
	},
};
</script>

<style lang="scss" scoped>
.nav {
	box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14),
		0px 1px 10px 0px rgba(0, 0, 0, 0.12);

	&-link {
		border: 1px solid #a6c9e2;
		border-radius: 1px;
		padding: 0 0.2rem;
		background: #fcfdfd url("~@/assets/ui-bg_inset-hard_100_fcfdfd_1x100.png") 50% bottom repeat-x;
		font-size: 1.5rem;
		color: #003399;
		font-family: "Lucida Grande", "Lucida Sans", Arial, sans-serif;
		line-height: initial;
		text-decoration: none;

		&:not(:last-child) {
			margin-right: 0.4rem;
		}

		&-active {
			border: 1px solid #79b7e7;
			background: #d0e5f5 url("~@/assets/ui-bg_glass_75_d0e5f5_1x400.png") 50% 50% repeat-x;
			font-weight: bold;
			color: #1d5987;
		}

		&.mi {
			display: inline-block;
			width: 130px;
			margin-bottom: 2px;
			text-align: left;
			white-space: nowrap;
		}
	}

	&-socials {
		a {
			display: inline-block;
			max-width: 30px;

			img {
				width: 100%;
				height: auto;
			}
		}
	}
}

.navigation {
	background-color: #fff !important;

	a {
		display: block !important;
		// padding: 0;
		margin-right: 0 !important;

		text-decoration: none;
		color: #000 !important;
	}

	.nav-link {
		color: transparent;
		border: none !important;
		font-size: 1.5rem !important;

		.nav-icon {
			margin-right: 1rem;
		}
	}

	.nav-link-active {
		border: none !important;
		background: none;
	}

	.router-link-active {
		background-color: rgba(121, 183, 231, 0.151);
	}
}

.top-navigation {
	background-color: #fff !important;
}
</style>

<style lang="scss" scoped>
.uppercase {
	text-transform: uppercase;
}

.nav-actions {
	display: flex;
	align-items: flex-end;
}

.custom-button-container {
	display: flex;
	flex: 1;
	flex-wrap: wrap;
	justify-content: flex-end;
	align-items: center;
}

.custom-button {
	display: flex;
	align-items: center;
	padding: 12px 18px;
	cursor: pointer;
	font-size: 17px;
	white-space: nowrap;
	position: relative;
	background-color: #fff !important;
}

.custom-button::before {
	content: "";
	position: absolute;
	top: -1.5rem;
	left: 50%;
	transform: translateX(-50%);
	border-left: 1.5rem solid transparent;
	border-right: 1.5rem solid transparent;
	border-top: 1.5rem solid #ba0c2f;
	opacity: 0;
	transition: opacity 0.3s;
}

.custom-button.nav-link-active::before {
	opacity: 1;
}

.custom-button:hover {
	color: #ba0c2f;
}

.custom-button:hover::before {
	opacity: 1;
}

/*
	Signed-in links: once the window is narrow enough for the links to wrap, the triangle above
	a link lands on the row above it, so on those widths the marker is an underline instead.
*/
@media (max-width: 959px) {
	.nav .custom-button {
		&::before {
			display: none;
		}

		&::after {
			content: "";
			position: absolute;
			left: 18px;
			right: 18px;
			bottom: 4px;
			height: 3px;
			background: #ba0c2f;
			transform: scaleX(0);
			transition: transform 0.2s ease;
		}

		&:hover::after,
		&.nav-link-active::after {
			transform: scaleX(1);
		}
	}
}

$shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14),
	0px 1px 10px 0px rgba(0, 0, 0, 0.12);

.public-header {
	--nav-top: 13.6rem;
	--nav-strip: 5.6rem;
	--p: 0;
	position: sticky;
	top: calc(-1 * var(--nav-top));
	z-index: 50;
	width: 100%;
	display: grid;
	grid-template-columns: 1fr 1fr;
	grid-template-rows: var(--nav-top) var(--nav-strip);
	padding: 0 3rem;
	background: #fff;
	box-shadow: $shadow;

	a {
		color: #000 !important;
		text-decoration: none;
	}
}

.public-header-top {
	grid-column: 1;
	grid-row: 1;
	display: flex;
	align-items: flex-end;
	justify-content: center;
}

/*
	Logo crossfade, driven by --p (0 at the top of the page, 1 once the strip is pinned).
	The stacked logo fades and recedes during the first part of the scroll; the horizontal
	one rises into the same centre line during the last part, so the two read as one motion.
*/
.logo-link {
	display: block;
	line-height: 0;
	opacity: clamp(0, calc(1 - var(--p) / 0.6), 1);
	transform: scale(calc(1 - 0.08 * var(--p)));
	transform-origin: 50% 100%;
}

.logo-primary {
	height: 12rem;
}

.public-header-strip {
	grid-column: 1 / -1;
	grid-row: 2;
	display: grid;
	grid-template-columns: 1fr 1fr;
	align-items: center;
}

.logo-horizontal {
	height: 4rem;
	justify-self: center;
	opacity: clamp(0, calc((var(--p) - 0.4) / 0.6), 1);
	transform: translateY(calc((1 - var(--p)) * 1.2rem)) scale(calc(0.9 + 0.1 * var(--p)));
}

.public-links {
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	align-items: center;
}

/*
	Public links mark hover and the current page with an underline instead of the triangle
	used in the signed-in menu: the triangle sits above the link, so it collides with the row
	above once the links wrap, and it is clipped once the strip is pinned to the top.
*/
.public-header .custom-button {
	&::before {
		display: none;
	}

	&::after {
		content: "";
		position: absolute;
		left: 18px;
		right: 18px;
		bottom: 4px;
		height: 3px;
		background: #ba0c2f;
		transform: scaleX(0);
		transition: transform 0.2s ease;
	}

	&:hover::after,
	&.router-link-exact-active::after {
		transform: scaleX(1);
	}
}

@media (prefers-reduced-motion: reduce) {
	.public-header .custom-button::after,
	.nav .custom-button::after {
		transition: none;
	}
}

@media (max-width: 1099px) {
	.public-header {
		--nav-strip: 5.2rem;
		grid-template-columns: 1fr;
	}

	.public-header-strip {
		grid-template-columns: auto 1fr;
	}

	.logo-horizontal {
		justify-self: start;
	}

	.public-links {
		flex-wrap: nowrap;
		justify-content: flex-end;
	}

	.custom-button {
		padding: 8px 12px;
		font-size: 15px;
	}
}

@media (max-width: 767px) {
	.public-header {
		--nav-top: 9.2rem;
		--nav-strip: 10rem;
		padding: 0 1.2rem;
	}

	.logo-primary {
		height: 8rem;
	}

	.public-header-strip {
		grid-template-columns: 1fr;
		grid-template-rows: auto 1fr;
		justify-items: center;
		row-gap: 0.4rem;
		padding-top: 0.4rem;
	}

	.logo-horizontal {
		height: 2.8rem;
		justify-self: center;
	}

	.public-links {
		flex-wrap: wrap;
		justify-content: center;
	}

	.custom-button {
		padding: 4px 10px;
		font-size: 14px;
	}

	.public-header .custom-button::after {
		left: 10px;
		right: 10px;
		bottom: 0;
	}
}
</style>
